import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-skeleton-template',
  templateUrl: './table-skeleton-template.component.html',
  styleUrls: ['./table-skeleton-template.component.scss'],
})
export class TableSkeletonTemplateComponent implements OnInit {
  @Input() columnData: any[] = [];
  @Input() showAdvanceSearch: boolean = true;
  Arr = Array; //Array type captured in a variable
  num = 10;
  dummyData: any[] = [];

  constructor() {}

  ngOnInit(): void {
    for (let i = 0; i < 9; i++) {
      this.dummyData.push({});
    }
  }
}
